<template>
  <div class="right popup-history">
    <span class="popup-head"> History </span>
    <span v-if="currentHistory && !currentHistory.length" class="popup-desc">
      Your action history will be displayed here
    </span>
    <div v-if="currentHistory && currentHistory.length" class="history">
      <table>
        <tr>
          <th>Date</th>
          <th>Event</th>
          <th>Points</th>
        </tr>

        <tr v-for="(item, index) in parsedHistory" :key="index">
          <td>{{ item.action_date | moment("DD MMM YY") }}</td>
          <td class="event">
            <span class="name">{{ item.parsedName }}</span>
            <span
              v-if="item.parsedName !== item.name && item.showSubtitle"
              class="dop"
              >{{ item.name }}</span
            >
            <span v-if="item.action === 'gift_purchase'" class="dop"
              >Local EB manager contact info: <b>{{ locationManager }}</b></span
            >
          </td>
          <td>
            <span
              class="ball"
              :class="{ points_negative: item.points_delta < 0 }"
              >{{
                item.points_delta > 0
                  ? "+" + item.points_delta
                  : item.points_delta
              }}</span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

const HISTORY_LAST_VIEWED_COOKIE = "HISTORY_LAST_VIEWED";
const DEFAULT_HISTORY_ITEMS = {
  purchase: "Purchase",
  gift_purchase: "Gift",
  badge: "Badge",
  registration: "Registration",
  referral: "Referral registration",
  referred: "Registration by referral",
  referred_purchase: "Referral purchase",
  promocode: "Promocode",
  enter_group: "Entering the group ",
  share_purchase: "Sharing in ",
  social_share: "Sharing in ",
  share_badge: "Sharing a badge in ",
  earn_badge: "Badge ",
  points_transfer: "Points transferred ",
};
export default {
  name: "AppPopupHistory",
  computed: {
    ...mapGetters(["currentHistory", "remoteConfig", "locationManager"]),
    parsedHistory() {
      return this.currentHistory.map((item) => {
        return {
          parsedName: this.historyName(item),
          showSubtitle: item.action !== "points_transfer",
          ...item,
        };
      });
    },
  },
  methods: {
    historyName(action) {
      if (!action) return "";
      let historyItems =
        (this.remoteConfig && this.remoteConfig.historyItems) ||
        DEFAULT_HISTORY_ITEMS;
      switch (action.action) {
        case "custom_action":
          return action.name || "";
        case "event":
          return action.name || "";
        case "extra":
          return action.name || "";
        case "points_transfer":
          let userName = action.user_name || "another user";
          let comment =
            action.name.split("with").length > 1
              ? action.name.split("with")[1].replace(" comment ", "")
              : "";
          return (
            `${
              action.points_delta > 0
                ? "Received points from"
                : "Sent points to"
            } ${userName} ${comment ? "with comment '" + comment + "'" : ""}` ||
            ""
          );
        case "sharing":
          switch (action.social_action) {
            case "like":
              return historyItems.enter_group + action.social_type;
            case "purchase":
              return historyItems.share_purchase + action.social_type;
            case "partner_page":
              return historyItems.social_share + action.social_type;
            case "badge":
              return historyItems.share_badge + action.social_type;
          }
      }
      return historyItems[action.action] || "";
    },
  },
  mounted() {
    Cookies.set(HISTORY_LAST_VIEWED_COOKIE, this.currentHistory[0].action_date);
  },
};
</script>
